export default "__VITE_PUBLIC_ASSET__ee1fca3a__"